package one.healthium.tutorial.navigation.screen

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.tutorial.domain.TutorialScreenConfig
import one.healthium.tutorial.screens.TutorialInfoScreen
import one.healthium.tutorial.screens.TutorialNotificationAccessScreen
import one.healthium.tutorial.screens.TutorialTransparencyAccessScreen

@Composable
internal fun TutorialScreenContent(component: TutorialScreenComponent) {
    Box(
        Modifier.fillMaxWidth().heightIn(max = 640.dp)
    ) {
        when (val child = component.screenConfig) {
            is TutorialScreenConfig.TutorialInfoScreenConfig -> {
                TutorialInfoScreen(
                    screenConfig = child,
                    eventDelegate = component,
                )
            }

            is TutorialScreenConfig.TutorialNotificationsAccessScreenConfig -> TutorialNotificationAccessScreen(
                screenConfig = child,
                eventDelegate = component,
            )

            is TutorialScreenConfig.TutorialTransparencyAccessScreenConfig -> TutorialTransparencyAccessScreen(
                screenConfig = child,
                eventDelegate = component,
            )
        }
    }
}